/**
 * Admin 앱 i18n 초기화 (한국어 고정)
 *
 * Super Admin은 단일 언어(한국어) 운영이지만, shared-learning의 학습자용 컴포넌트
 * (Quiz, Toon 등)가 `useTranslation()` 을 사용하므로 i18next 인스턴스가 반드시
 * 초기화되어 있어야 한다. 초기화가 없으면 콘텐츠 검수 미리보기에서 `t('...')`
 * 가 key 문자열을 그대로 반환해 화면에 노출된다.
 *
 * 현재는 shared-learning 의 player/quiz 리소스만 로드한다. admin 자체 다국어
 * 처리가 필요해지면 LC `apps/lc/src/i18n/index.ts` 패턴을 따라 namespace를 확장할 것.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { sharedLearningResources } from '@quebon/shared-learning'

i18n.use(initReactI18next).init({
  resources: {
    ko: { ...sharedLearningResources.ko },
    en: { ...sharedLearningResources.en },
  },
  lng: 'ko',
  fallbackLng: 'ko',
  defaultNS: 'player',
  interpolation: { escapeValue: false },
})

export default i18n
